import { useMutation, UseMutationResult } from 'react-query';
import { ErrorWithData } from 'task-manager/bench-services-api/ErrorWithData';
import { BusinessService, EditBusinessServiceInput } from '../types';

async function edit(apiUrl: string, input: EditBusinessServiceInput): Promise<BusinessService> {
  if (!apiUrl) throw new Error('Required properties are not set');

  const response: Response = await fetch(`${apiUrl}/business-service/${input.businessServiceId}`, {
    method: 'PUT',
    body: JSON.stringify(input),
    credentials: 'include',
  });

  if (!response.ok) {
    const error = (await response.json()) as Record<string, unknown>;
    throw new ErrorWithData(
      'Failed to edit business service. Try a different identifier to make sure no two services are the same. If the problem persists contact support. ',
      error,
    );
  }
  return (await response.json()) as BusinessService;
}

interface UseEditBusinessServiceProps {
  handleError: (error: Error) => void;
}

export const useEditBusinessService = ({
  handleError,
}: UseEditBusinessServiceProps): UseMutationResult<
  BusinessService,
  Error,
  EditBusinessServiceInput
> => {
  const apiUrl = window.BENCH?.auApi?.SETUP_BUSINESS_SERVICE_API_URL || '';

  return useMutation({
    mutationFn: input => edit(apiUrl, input),
    onError: handleError,
  });
};
